
import Vue from "vue";
import ASCAArtIncLink from "./ASCAArtIncLink.vue";
import BylawsLink from "./BylawsLink.vue";

export default Vue.extend({
  name: "KennelSignatureText",
  components: { ASCAArtIncLink, BylawsLink }
});
